'use client';

import { useEffect } from 'react';

/**
 * This component for force scroll up, remove it if it works in next router
 *
 * @returns null
 */
export default function ScrollUp() {
  useEffect(() => window.scrollTo(0, 0), []);

  return null;
}
